import { call, put, takeEvery, takeLeading } from 'typed-redux-saga'
import { SettingModel } from 'Models'
import { Deserialize } from 'cerialize'
import { errorHandler, notifyMessageCreator, settingApi, SettingNS, settingSlice } from 'Modules'

function* getAllSetting() {
	try {
		const res = yield* call(settingApi.getAllSetting)
		const entries = res.map((item): SettingModel => Deserialize(item, SettingModel))
		const result: Map<string, SettingModel> = new Map()
		entries.forEach((entry): Map<string, SettingModel> => result.set(entry.key, entry))
		yield* put(settingSlice.actions.setAll(result))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getSetting(action: SettingNS.GetSetting) {
	try {
		const res = yield* call(settingApi.getSetting, action.payload)
		const result = Deserialize(res, SettingModel)
		yield* put(settingSlice.actions.setSetting(result))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* updateSetting(action: SettingNS.UpdateSetting) {
	try {
		const { setting, key, callback } = action.payload
		const res = yield* call(settingApi.updateSetting, setting, key)
		const result = Deserialize(res, SettingModel)
		yield* put(settingSlice.actions.setSetting(result))
		yield* call(notifyMessageCreator, 'common.settings_update.success')
		yield* call(getAllSetting)
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getEventsSetting() {
	try {
		yield* call(settingApi.getEventsSetting)
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* settingSaga() {
	yield* takeLeading(settingSlice.actions.getAll.type, getAllSetting)
	yield* takeEvery(settingSlice.actions.getSetting.type, getSetting)
	yield* takeEvery(settingSlice.actions.updateSetting.type, updateSetting)
	yield* takeEvery(settingSlice.actions.getEvents.type, getEventsSetting)
}
